import { Check, X } from 'lucide-react';
import { getPasswordChecks, getPasswordScore, getPasswordLevel, PASSWORD_REQUIREMENTS } from '@/lib/passwordStrength';

// Live strength meter + requirement checklist shown under any "new password"
// field (client/photographer signup, admin & client change-password).
export const PasswordStrengthMeter = ({ password, testIdPrefix = 'password-strength' }) => {
  if (!password) return null;
  const checks = getPasswordChecks(password);
  const score = getPasswordScore(password);
  const level = getPasswordLevel(score);

  return (
    <div className="space-y-2 pt-1" data-testid={`${testIdPrefix}-meter`}>
      <div className="flex items-center gap-2">
        <div className="flex-1 flex gap-1">
          {[0, 1, 2, 3, 4].map((i) => (
            <span
              key={i}
              className={`h-1.5 flex-1 rounded-full transition-colors duration-200 ${
                i < score ? level.barClass : 'bg-[hsl(var(--lxra-border))]'
              }`}
            />
          ))}
        </div>
        <span
          className={`text-[11px] font-medium uppercase tracking-[0.08em] shrink-0 ${level.textClass}`}
          data-testid={`${testIdPrefix}-label`}
        >
          {level.label}
        </span>
      </div>
      <ul className="grid grid-cols-1 gap-y-1">
        {PASSWORD_REQUIREMENTS.map((r) => (
          <li
            key={r.key}
            data-testid={`${testIdPrefix}-check-${r.key}`}
            className={`flex items-center gap-1.5 text-[11px] transition-colors duration-150 ${
              checks[r.key] ? 'text-emerald-400' : 'text-[hsl(var(--lxra-muted))]'
            }`}
          >
            {checks[r.key] ? <Check className="h-3 w-3 shrink-0" /> : <X className="h-3 w-3 shrink-0 opacity-40" />}
            {r.label}
          </li>
        ))}
      </ul>
    </div>
  );
};
